import type { XingletInterface } from '../xinglet-helpers';
import { XingletWrapper } from '../xinglet-helpers';

import type { TemplateProps } from '.';

export type TemplateElegantProps = TemplateProps;
export type TemplateElegantXinglet = XingletInterface<TemplateElegantProps>;

export const Elegant = XingletWrapper<TemplateElegantProps>(
  `@xing-com/crate-lebenslauf-templates-elegant`
);
